// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/styles.scss
// module id = 1114
// module chunks = 0